import { setCartridgeUrl } from './shipping-utils';
import { stateReexButton } from './shipping-reex';
import { init as initStateButtonsHandler } from '../state-button-handler';

const createLocations = () => {
  const relayPoints = cube.$$('input[data-type="relay-point"]');
  const locations   = [];

  for(let i=0;i < relayPoints.length;i++) {
    const location = [];
    location.push(relayPoints[i].dataset.name, relayPoints[i].dataset.lat, relayPoints[i].dataset.long);
    locations.push(location);
  }
  return locations;
};

const createMap = () => {
  const locations = createLocations();
  const markers = [];
  let marker;

  // Exit - do not display map - if we can't find any location
  if (locations.length === 0) return;

  let map = new window.google.maps.Map(document.getElementById('maps-relay'), {
    zoom: 15,
    center    : new window.google.maps.LatLng(locations[0][1], locations[0][2]),
    mapTypeId : window.google.maps.MapTypeId.ROADMAP
  });

  const infowindow  = new window.google.maps.InfoWindow();
  const bounds      = new window.google.maps.LatLngBounds();

  for (i = 0; i < locations.length; i++) {
    marker = new window.google.maps.Marker({
      position: new window.google.maps.LatLng(locations[i][1], locations[i][2]),
      map,
      icon: '/assets/images/pin.png'
    });

    markers.push(marker);
  }


  markers.forEach((marker, index) => {
    marker.addListener('click', () => {

      const inputToCheck = cube.$(`.checkout__shipping__relay-point .checkout__shipping__input[data-index="${  index  }"]`);

      inputToCheck.click();

      $('.checkout__shipping__stores').animate({ scrollTop: inputToCheck.nextElementSibling.offsetTop }, 180);

      infowindow.setContent(locations[index][0]);
      infowindow.open(map, marker);
    });
    bounds.extend(marker.position);
  });

  cube.event.on('checkout:relay-points-success', (element) => {
    $('.checkout__shipping__stores').animate({ scrollTop: element.nextSibling.offsetTop }, 200);
    if (!cube.ui.isMobile()) {
      window.google.maps.event.trigger(markers[element.dataset.index], 'click');
    }
  });

  map.fitBounds(bounds);

  // See relay points on mobile
  const mapButtons = cube.$$('.checkout__shipping__store__map-button');
  for(let i=0;i < mapButtons.length;i++) {
    mapButtons[i].addEventListener('click', mobileSearch);
  }
};

function closeRelayPointModal (event) {
  event.preventDefault();
  event.target.closest('.checkout__shipping__modal-relay-points').classList.remove('checkout__shipping__modal-relay-points--open');
  cube.$id('modal-relay-points-map').innerHTML = '';
};

function mobileSearch (event) {
  let marker = [];
  const inputCheck  = event.target.closest('.checkout__shipping__stores').$('.checkout__shipping__input:checked');
  const dataLat     = parseFloat(inputCheck.dataset.lat);
  const dataLng     = parseFloat(inputCheck.dataset.long);
  const markers     = [];
  const relayPosition = {lat: dataLat, lng: dataLng};


  cube.$('.checkout__shipping__modal-relay-points').classList.add('checkout__shipping__modal-relay-points--open');

  // Remove previous markers
  for (let i = 0; i < markers.length; i++) {
    markers[i].setMap(null);
  }

  // Create new Map
  const map = new window.google.maps.Map(document.getElementById('modal-relay-points-map'), {
    zoom: 16,
    center: relayPosition,
    mapTypeId: window.google.maps.MapTypeId.ROADMAP,
    disableDefaultUI: true
  });

  // Create new marker, for the selected relay point
  marker = new window.google.maps.Marker({
    position: relayPosition,
    map
  });

  markers.push(marker);

  cube.$id('js-modal-relay-points-header').innerHTML = inputCheck.nextElementSibling.textContent.trim();
  cube.$id('js-modal-relay-points-leadtime').innerHTML = inputCheck.closest('.checkout__shipping__wrapper').$('.lead-time-info').textContent;
  cube.$id('js-close-relay-points').addEventListener('click', closeRelayPointModal);
};

/*
 * Create google Map after search
 */
function search(event) {

  let params = {};
  //Bind ignore rules from home delivery when you search relay point
  $('#js-checkout-shipping').validate().settings.ignore='#home-delivery input,:hidden:not(.selectpicker)';

  if($('#js-checkout-shipping').valid()) {
	  const searchRelayPointUrl = '/com/decathlon/cube/commerce/order/relaypoint/RelayPointSearchFormActor/searchRelayPointByPostalCode';
	  const searchRelayPointDHLUrl = '/com/decathlon/cube/commerce/order/relaypoint/RelayPointSearchFormActor/searchRelayPointByPostalCodeDHL';

    if(event.target.closest('.checkout__shipping__search-input').classList.contains('checkout__shipping__dhl')) {

      setCartridgeUrl('checkout.shipping.ch_shippingrelaypoint', searchRelayPointDHLUrl, 'relay-point-details');

      params  = {
        "&postalCode" : cube.$id('relayinput').value.trim(),
        postNumber : cube.$id('relayinput-dhl').value.trim(),
        context: cube.$id('relay-point').dataset.context
      };
    } else {
      setCartridgeUrl('checkout.shipping.ch_shippingrelaypoint', searchRelayPointUrl, 'relay-point-details');
      params  = {
        "&postalCode" : cube.$id('relayinput').value.trim().toUpperCase(),
        context: cube.$id('relay-point').dataset.context
      };
    }

    cube.cartridge('relay-point-details').before(() => {
      cube.ui.displayLoader(cube.$('.checkout__shipping__content__search'));
    }).after(() => {
      if(cube.$('.checkout__shipping__search-result')) cube.$('.checkout__shipping__search-result').classList.add('checkout__shipping__search-result--deployed');
      stateReexButton();
      initStateButtonsHandler();
      createMap();
      cube.ui.hideLoader(cube.$('.checkout__shipping__content__search'));
    }).reload(params);

    event.preventDefault();
    event.stopPropagation();
  }

  return false;
};

/*
 * Update shipping group
 */
function updateRelayPointShippingGroup (event) {
  const postUrl = 'rest/model/com/decathlon/cube/commerce/order/purchase/CreateRelayPointShippingGroupActor/addRelayPointShippingGroup';
  const input   = event ? event.currentTarget : cube.$('[name="delivery-type"]:checked');

  const params  = {
    locationCode : input.value,
    retailNetworkId : input.dataset.retailnetworkid,
    shippingOptionId: input.dataset.rpshippingoptionid,
    context: cube.$id('relay-point').dataset.context
  };

  if(input.dataset.postnumber) {
    params.postNumber = input.dataset.postnumber;
  }

  cube.ajax.form(postUrl, params).onSuccess((response) => {
    if(response && response.responseTO && response.responseTO.errors[0] && response.responseTO.errors[0].code) {
      cube.$('.dkt-checkout-primary-button').classList.add('error-shipping');
      cube.alert.error(window.Messages(response.responseTO.errors[0].code));
      initStateButtonsHandler();
    } else {
      cube.$('.dkt-checkout-primary-button').classList.remove('error-shipping');
      cube.event.send('checkout:refresh-order-summary');
      cube.event.send('checkout:relay-points-success', input);
    }
  }).call();
};

export { search, updateRelayPointShippingGroup };



// WEBPACK FOOTER //
// ./src/modules-es5/checkout/shipping/relay-point.js